import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Insurer } from '@/codebook/insurer/_types/insurer.type';
import { CreateInsurance, Insurance } from '@/codebook/insurer/insurer-package/_types/insurer-package.type';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Product, Result } from '@/reservation/reservation.model';
import { Service } from '@/services/service.model';

@Injectable({
	providedIn: 'root',
})
export class InsurerApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getInsurers(offset: number, limit: number): Observable<Result<Insurer>> {
		return this.httpClient.get<Result<Insurer>>(
			`${this.apiUrl}/insurance/insurer/?offset=${offset}&limit=${limit}`,
		);
	}

	getInsurer(id: number): Observable<Insurer> {
		return this.httpClient.get<Insurer>(`${this.apiUrl}/insurance/insurer/${id}/`);
	}

	getInsurances(insurerId: number): Observable<Result<Insurance>> {
		return this.httpClient.get<Result<Insurance>>(`${this.apiUrl}/insurance/?insurer=${insurerId}`);
	}

	getInsurance(id: number): Observable<Insurance> {
		return this.httpClient.get<Insurance>(`${this.apiUrl}/insurance/${id}/`);
	}

	createInsurance(insurance: CreateInsurance): Observable<void> {
		return this.httpClient.post<void>(`${this.apiUrl}/insurance/`, insurance);
	}

	updateInsurance(id: number, insurance: Insurance): Observable<void> {
		return this.httpClient.put<void>(`${this.apiUrl}/insurance/${id}/`, insurance);
	}

	overwriteInsurance(id: number, insurance: Insurance): Observable<void> {
		return this.httpClient.post<void>(`${this.apiUrl}/insurance/${id}/overwrite/`, insurance);
	}

	getProductInsurance(insuranceId: Insurance['id']): Observable<Result<Product>> {
		return this.httpClient.get<Result<Product>>(`${this.apiUrl}/product/?insurance=${insuranceId}`);
	}

	updateInsurer(id: number, payload: Insurer): Observable<Insurer> {
		return this.httpClient.put<Insurer>(`${this.apiUrl}/insurance/insurer/${id}/`, payload);
	}

	createInsurer(payload: Insurer): Observable<Insurer> {
		return this.httpClient.post<Insurer>(`${this.apiUrl}/insurance/insurer/`, payload);
	}

	getResignationServices(): Observable<Result<Service>> {
		return this.httpClient.get<Result<Service>>(`${this.apiUrl}/offer/service/?limit=999&service_type=9`);
	}

	getResignationServiceByName(searchValue: string): Observable<Result<Service>> {
		return this.httpClient.get<Result<Service>>(`${this.apiUrl}/offer/service/?name=${searchValue}&service_type=9`);
	}

	assignInsurerToService(insurerId: number, serviceId: number): Observable<void> {
		return this.httpClient.patch<void>(`${this.apiUrl}/offer/service/${serviceId}/`, {
			insurer: insurerId,
		});
	}
}
